import { FC, FormEvent, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks';
import { errorToast, successfulToast } from 'utils';
import { ILinkModel } from 'store/models/tabsStore';
import { HStack, BaseInput } from 'components';
import { Button, Text, VStack } from 'components/ui';

type Props = {
  onClose: () => void;
  link: ILinkModel;
  slug: string;
};

const DEFAULT_URL = 'https://eis24.me/instructions/';

export const AddUrlWindow: FC<Props> = observer(({ onClose, link, slug }) => {
  const { tabs } = useStore();
  const [newUrl, setNewUrl] = useState<string>('');
  const [errorUrl, setErrorUrl] = useState<boolean>(false);

  const handleChangeValue = (value: string) => {
    setNewUrl(value);
    const check = /^https:\/\/eis24\.me\/instructions\/.*/.test(value);
    setErrorUrl(!check);
  };

  const handleClose = () => {
    onClose();
    setNewUrl('');
  };

  const handleEditLink = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (newUrl === link?.help_link) {
      successfulToast('Эта ссылка уже записана');
      handleClose();

      return;
    }

    try {
      await tabs.sendNewLink(link?.id as string, {
        resource_name: slug,
        help_link: newUrl,
      });

      successfulToast('Ссылка сохранена');
      handleClose();

      await tabs.getTabLinks();
    } catch (error) {
      errorToast();

      return;
    }
  };

  return (
    <VStack as="form" onSubmit={handleEditLink}>
      <Text variant="heading-3">Изменение URL-адрес</Text>

      <BaseInput
        width="inherit"
        value={newUrl}
        onChange={(e) => handleChangeValue(e.target.value)}
        placeholder={`${DEFAULT_URL}...`}
        state={errorUrl ? 'error' : 'default'}
        message={{
          error: `URL должен начинаться с ${DEFAULT_URL}`,
        }}
      />

      <HStack flex={1} align="center" justify="flex-end" gap={8}>
        <Button mode="neutral" onClick={handleClose}>
          Отмена
        </Button>
        <Button
          type="submit"
          mode="accent"
          pending={tabs.requestsStates.editLinkTab.pending}
          disabled={!newUrl || errorUrl}
        >
          Сохранить
        </Button>
      </HStack>
    </VStack>
  );
});
